import { JSX } from 'react'

import { IconProps } from '../../icon'

const FavoriteOff: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M39.5042 15.7774V15.7446C38.2897 12.3142 35.0235 10 31.3798 10C28.2284 10 25.5039 11.7234 23.9939 14.251C22.4838 11.7234 19.7593 10 16.608 10C12.9642 10 9.69804 12.3142 8.48347 15.7446V15.7774C4.87259 26.6921 22.648 36.5236 23.403 36.9339C23.5835 37.0324 23.7969 37.0816 23.9939 37.0816C24.1908 37.0816 24.3878 37.0324 24.5847 36.9339C25.3397 36.5236 43.1151 26.6921 39.5207 15.7774H39.5042ZM23.9939 34.4391C21.0559 32.7157 8.17162 24.5584 10.8141 16.5488C11.684 14.1033 14.0147 12.4784 16.608 12.4784C20.0055 12.4784 22.7629 15.2358 22.7629 18.6333C22.7629 19.3062 23.3209 19.8643 23.9939 19.8643C24.6668 19.8643 25.2248 19.3062 25.2248 18.6333C25.2248 15.2358 27.9822 12.4784 31.3798 12.4784C33.973 12.4784 36.3037 14.1197 37.1736 16.5488C39.8161 24.5584 26.9318 32.7157 23.9939 34.4391Z'
      fill='black'
    />
  </svg>
)

export default FavoriteOff
